import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { setGenerateReportData, setStateValue } from '../../../../../../actions/actionsModuloRelatorio';
import { changeValue, changeCache } from '../../../../../../actions/actionsPainelGeral';
import * as PainelGeralService from '../../../InfoPanel/services';
import { useDebounce } from '../../../../../../hooks';
import { getModelPanel } from '../../../InfoPanel/utils';
import { NotificationMessage } from '../../../../../../components';

export const useSelectCnpj = () => {
  const dispatch = useDispatch();
  const debounce = useDebounce();

  const { cnpj, moduloRelatorioData, filtrosData } = useSelector(
    state => ({
      filtrosData: state.painelGeralDataReducer.filtrosData,
      cnpj: state.moduloRelatorioDataReducer?.cnpj,
      moduloRelatorioData: state.moduloRelatorioDataReducer?.moduloRelatorioData,
    }),
    shallowEqual,
  );

  const setList = (list, query) => {
    const normalize = v => v.replace(/^0+/, '');

    const hasValue = typeof query === 'object' && query.length;
    const newValue = hasValue ? query : [];

    const data = list.map(item => ({
      label: item.key,
      value: item.key.match(/^\d+/)?.[0],
    }));

    const removeDuplicate = data.filter(i => !cnpj.value.includes(i.value));

    const concatList = cnpj.value.length ? cnpj.cache.concat(removeDuplicate) : data;

    const newCache = hasValue ? [...cnpj.cache, ...removeDuplicate] : cnpj.cache;

    const listValue = [...new Set([...cnpj.value.map(normalize), ...newValue.map(normalize)])];

    const reportData = newCache.map(item => item.label);

    dispatch(
      setStateValue('cnpj', {
        ...cnpj,
        lista: concatList,
        cache: newCache,
        value: listValue,
      }),
    );
    dispatch(setGenerateReportData('cnpj', reportData));
  };

  const addCNPJ = item => {
    const newValue = cnpj.value.concat(item.value);
    const newCache = cnpj.cache.concat(item);
    const addItem = moduloRelatorioData.cnpj?.concat(item.label);
    const filtrosDataCnpjValue = newCache.map(item => item.label);

    dispatch(
      setStateValue('cnpj', {
        ...cnpj,
        cache: newCache,
        value: newValue,
      }),
    );
    dispatch(changeValue(filtrosDataCnpjValue, 'cnpj'));
    dispatch(changeCache('cnpj', newCache));
    dispatch(setGenerateReportData('cnpj', addItem));
  };

  const removeCNPJ = item => {
    const removeItem = moduloRelatorioData.cnpj?.filter(i => i !== item.label);
    const removedCache = cnpj.cache.filter(i => i.value !== item.value);
    const newValue = cnpj.value.filter(i => i !== item.value);
    dispatch(
      setStateValue('cnpj', {
        ...cnpj,
        cache: removedCache,
        value: newValue,
      }),
    );
    dispatch(changeValue(newValue, 'cnpj'));
    dispatch(changeCache('cnpj', removedCache));
    dispatch(setGenerateReportData('cnpj', removeItem));
  };

  const handleSelectCNPJ = item => {
    const hasValue = cnpj?.value?.includes(item.value);
    if (hasValue) {
      removeCNPJ(item);
    } else {
      addCNPJ(item);
    }
  };

  const handleCleanCNPJ = () => {
    dispatch(setStateValue('cnpj', { ...cnpj, cache: [], value: [] }));
  };

  const handleSearchCNPJ = inputValue => {
    let query;
    let cnpjData;

    const isCopyAndPaste = inputValue && typeof inputValue === 'string' && inputValue.match(/^\d+ \d+[\d+ ]*$/);

    if (isCopyAndPaste) {
      if (inputValue.split(' ').length > 1000) {
        NotificationMessage('error', 5000, 'É possível selecionar até 1000 CNPJs');
        return;
      }

      query = inputValue.split(' ');
      cnpjData = {
        ...filtrosData,
        cnpj: {
          ...filtrosData.cnpj,
          value: [...filtrosData.cnpj.value, ...query],
        },
      };
      dispatch(setStateValue('cnpj', { ...cnpj, value: query }));
    } else {
      query = typeof inputValue === 'string' ? inputValue : '';
    }

    debounce(() => {
      dispatch(getItensFiltro(getModelPanel(isCopyAndPaste ? cnpjData : filtrosData, query, 'cnpj'), query));
    });
  };

  function getItensFiltro(params, query) {
    return dispatch => {
      PainelGeralService.getItensFiltros(params).then(data => {
        if (data) {
          setList(data, query);
        }
      });
    };
  }

  return {
    cnpjHandlers: {
      handleCleanCNPJ,
      handleSearchCNPJ,
      handleSelectCNPJ,
    },
  };
};
